"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageEntryKey = void 0;
var StorageEntryKey;
(function (StorageEntryKey) {
    StorageEntryKey["VIRGIN_MEDIA_HBA_PROXY"] = "virginMediaHbaProxy";
})(StorageEntryKey = exports.StorageEntryKey || (exports.StorageEntryKey = {}));
